import Button from "components/atoms/Button/Button"
import Lottie from "lottie-react"
import { Link } from "react-router-dom"
import successLotie from "assets/lotties/success.json";
interface Props {
    link: string
    linkLabel: string
    title: string
    description: string
}
export const Success = ({ link, linkLabel, title, description }: Props) => {
    return (
        <div className="flex flex-col items-center justify-center gap-2 h-fit w-full m-auto">
            <Lottie animationData={successLotie} loop={false} width={40} className="max-w-[200px]" />
            <h1 className="font-bold capitalize text-2xl">{title}</h1>
            <small className="text-gray-400 text-center text-lg">{description}</small>
            <Link to={link} className=" mt-4">
                <Button size="sm" action="button" buttonContainerClassName="gap-4 flex-row-reverse" iconName="arrow-right" iconSize={16} type="primary">
                    {linkLabel}
                </Button>
            </Link>
        </div>
    )
}